import api from "../api";

const listInvoices = async ({ storeCode, period, page = 1, pageSize = 25 }) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/management/stores/${encodeURIComponent(
    storeCode
  )}/invoices`;
  const response = await api.get(endpoint, {
    params: {
      period,
      page,
      pageSize,
    },
  });
  return response.data;
};

export default listInvoices;
